import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { ArrowRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useForm, Controller } from "react-hook-form";
import { BiSolidCheckSquare } from "react-icons/bi";
import { useVaccinationDeleteAPI } from "@/app/hooks/api_hooks/Vaccination/useVaccinationDeleteAPI";
import { useVaccinationHistoryListAPI } from "@/app/hooks/api_hooks/Vaccination/useVaccinationHistoryListAPI";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ROUTES } from "@/app/routes";
import { useVaccinationSingleRecordAPI } from "@/app/hooks/api_hooks/Vaccination/useVaccinationSingleRecordAPI";

const IteamDeleteComponent = ({ open, setOpen, vaccination_id, vaccination_file }) => {
  const cancelButtonRef = useRef(null);
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [loader, setLoader] = useState(false);

  const { routeState } = useRouteInfo(ROUTES.ROOT.children.CUSTOMER_PROFILE.id);
  const { customerId, petId } = routeState.state as ICustomerProfileState;
  const deleteVaccination = useVaccinationDeleteAPI();
  const { execute: fetchVaccinationHistoryList } = useVaccinationHistoryListAPI();
  const { execute: singleDataFetch, singleRecord } = useVaccinationSingleRecordAPI();

  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {
      billingStatus: "Items_already_billed",
      otherReason: null,
    },
  });

  const onSubmit = (data) => {
    setLoader(true);
    deleteVaccination(vaccination_id, formHook.watch("otherReason")).then(({ status }) => {
      if (status) {
        setOpen(false);
        fetchVaccinationHistoryList(petId, customerId);
      } else {
        setLoader(false);
      }
    });
  };

  useEffect(() => {
    const billing = formHook.watch("billingStatus");
    if (billing === "Other") {
      setIsOtherSelected(true);
    } else {
      setIsOtherSelected(false);
    }
  }, [formHook.watch("billingStatus")]);

  

  useEffect(() => {
    if (vaccination_id) {
      const constructedBody = {
        vaccination_id: vaccination_id,
      };
      singleDataFetch(constructedBody);
    }
  }, [vaccination_id]);

  const handelViewOcrFile = (img:any) => {
    window.open(img, "blank");
  };
  
    const fileDataList: any[] = (() => {
    return Array.isArray(vaccination_file) ? vaccination_file : [];
  
})()

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <form
                onSubmit={formHook.handleSubmit(onSubmit)}
                className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-2xl"
              >
                {loader ? (
                  <TableSkeleton />
                ) : (
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 ">
                    <div className="flex justify-between items-center mt-2 pb-4">
                      <h2 className="text-sm font-semibold">
                        Are you sure you want to delete this vaccination records
                      </h2>

                      <span
                        onClick={() => {
                          setOpen(false);
                          formHook.reset();
                        }}
                      >
                        <XMarkIcon className="h-4 w-4 cursor-pointer" />
                      </span>
                    </div>
                    <div className="pb-4">
                      <div className="overflow-hidden rounded-lg border border-gray-300 sm:rounded-xl">
                        <table className="min-w-full">
                          <thead className="bg-[#F1F1F3]">
                            <tr>
                              <th className="p-3 text-left text-[10px] sm:text-xs 2xl:text-sm font-semibold text-gray-900 ">
                                Vaccine Name
                              </th>
                              <th className="p-3 text-left text-[10px] sm:text-xs 2xl:text-sm font-semibold text-gray-900 sm:pl-6">
                                Given Date
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="border-t">
                              <td className="p-3 text-[10px] sm:text-xs 2xl:text-sm font-medium text-gray-500 ">
                                {singleRecord?.unique_dose_key}
                              </td>
                              <td className="p-3 text-[10px] sm:text-xs 2xl:text-sm font-medium text-gray-500 sm:pl-6">
                                {singleRecord?.given_date}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    { fileDataList?.length>0 && fileDataList?.map((i) => {
                        const fileName = i?.split("/")?.pop();

                        return (
                          <div>
                            <div className="mt-2 ">
                              <div className=" rounded-xl p-4 border ">
                                <div className="flex justify-between text-[#475467] text-[10px] sm:text-xs 2xl:text-sm   ">
                                  <div className="flex flex-col">
                                    <p className="font-medium flex items-center gap-2 text-sm">
                                      <img
                                        src="https://vetic-img.s3.ap-south-1.amazonaws.com/quick_commerce//misc/dscshIcon.svg"
                                        alt="copy"
                                      />{" "}
                                      <span className="-mt-1 font-medium">{fileName || "No File Available"}</span>
                                    </p>
                                  </div>

                                  <p
                                    className="text-[10px] sm:text-xs 2xl:text-sm text-violet-500 px-1 rounded flex items-center gap-1 font-semibold cursor-pointer"
                                    onClick={() => handelViewOcrFile(i)}
                                  >
                                    View <span>{/* <ArrowRightIcon className="w-4 h-4" /> */}</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    <div className="flex flex-col py-8 gap-4">
                      <Controller
                        name="otherReason"
                        control={formHook.control}
                        rules={{
                          required: "Add Reason for deletion",
                          validate: (value) => value.trim() !== "" || "Reason cannot be blank.",
                        }}
                        render={({ field }) => (
                          <textarea
                            {...field}
                            rows={4}
                            placeholder="Add Reason for deletion...."
                            className={`w-full p-2 rounded-xl text-xs border ${
                              formHook.watch("otherReason") ? "border border-red-400" : "border-gray-300"
                            } focus:outline-none focus:ring-0 focus:border-gray-300`}
                          />
                        )}
                      />

                      {/* {formHook.formState.errors.otherReason && (
                        // <p className="text-red-500 text-xs mt-1">{formHook.formState.errors.otherReason}</p>
                      )} */}
                    </div>
                    <div className="flex justify-end gap-4 mt-4">
                      <button
                        type="button"
                        onClick={() => {
                          setOpen(false);
                          formHook.reset();
                        }}
                        className="rounded-md bg-[#72767f1a] px-4 py-2 text-sm text-[#000000] font-medium "
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className={`rounded-md ${formHook.watch("otherReason")?.trim() ? "bg-red-600" : "bg-[#949494] cursor-not-allowed"}  font-bold px-4 py-2 text-sm text-white `}
                      >
                        Yes,Delete
                      </button>
                    </div>
                  </div>
                )}
              </form>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default IteamDeleteComponent;

const TableSkeleton = () => {
  return (
    <div className="bg-white mt-8 h-[300px] overflow-scroll animate-pulse">
      <table className="rounded-md divide-y divide-gray-200 min-w-full">
        <thead className="top-0 sticky bg-[#F7F7F7] shadow-sm rounded-md">
          <tr>
            {/* Skeleton Header */}
            {[...Array(3)].map((_, index) => (
              <th
                key={index}
                className="px-3 py-3 text-left text-xs font-medium text-gray-300 capitalize tracking-wider"
              >
                <div className="h-3 bg-gray-200 rounded w-3/4"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {/* Skeleton Rows */}
          {[...Array(3)].map((_, rowIndex) => (
            <tr key={rowIndex} className="border-b">
              {[...Array(6)].map((_, colIndex) => (
                <td key={colIndex} className="px-3 py-4 whitespace-nowrap text-xs font-normal text-gray-300">
                  <div className="h-3 bg-gray-200 rounded w-full"></div>
                </td>
              ))}
              <td className="px-3 py-4 whitespace-nowrap text-xs font-normal text-gray-300">
                <div className="h-6 bg-gray-200 rounded w-1/2"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
